import React from 'react';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import ConfiguracoesPlataforma from '@/pages/ConfiguracoesPlataforma';

const ConfiguracoesPlataformaPage = () => {
  return (
    <DashboardLayout title="Configurações da Plataforma">
      <div data-testid="configuracoes-plataforma-page">
        <ConfiguracoesPlataforma />
      </div>
    </DashboardLayout>
  );
};

export default ConfiguracoesPlataformaPage;
